// Terminologia nautica: "bussola magnetica" (non "compasso"), "compensazione" per la
// correzione delle deviazioni, "tabella delle deviazioni" per la deviation card,
// "società di classificazione", "comandante" per il capitano della nave.
const it = {
    nav: {
        about: 'Chi siamo',
        services: 'Servizi',
        contact: 'Contatti',
        language: 'Lingua',
    },
    slides: {
        s1Subtitle: 'Servizi e certificati per bussole magnetiche dal 1939.',
        readAbout: 'Scopri chi siamo',
        s2Before: 'Siamo la prima azienda ad aver introdotto la ',
        s2Highlight: 'compensazione da remoto',
        s2After: ' delle bussole magnetiche.',
        s2Text: 'Fate compensare la vostra bussola magnetica da remoto e ottenete tutti i certificati necessari da presentare a qualsiasi autorità nazionale o internazionale.',
        learnMore: 'Scopri di più',
        getQuote: 'Richiedi un preventivo',
        imgAlt: 'Plancia di una nave con strumenti di navigazione',
    },
    about: {
        title: 'Chi siamo',
        imgAlt: 'Bussola magnetica sul ponte di una nave',
        since: 'Dal',
        eyebrow: 'La nostra storia',
        heading: 'Ripariamo e tariamo bussole magnetiche da oltre 85 anni.',
        text: "Siamo l'unico laboratorio autorizzato in Argentina a rilasciare certificati con tutte le convalide legali e internazionali, riconosciuti in tutto il mondo da qualsiasi società di classificazione o autorità di guardia costiera.",
        checks: [
            "Autorizzati dalla PNA (Argentina, Stato membro dell'IMO)",
            'Primo servizio di taratura delle bussole interamente da remoto',
            'Taratura di bussole magnetiche e certificati in meno di 24 ore',
        ],
        counters: ['Certificati rilasciati', 'Bussole riparate', 'Interventi completati'],
        partner: 'Centro assistenza ufficiale e distributore',
    },
    services: {
        title: 'Servizi',
        flagship: 'Il nostro servizio di punta',
        remoteTitle: 'Taratura da remoto',
        remoteSubtitle: 'Tarate la vostra bussola magnetica durante la navigazione, ovunque nel mondo. Senza tecnico a bordo e senza scalo in porto.',
        steps: [
            { title: 'Inviate i dati.', text: 'Il comandante carica le informazioni della bussola sulla nostra piattaforma online.' },
            { title: 'Ricevete le istruzioni.', text: 'Passaggi semplici e dettagliati per correggere le deviazioni.' },
            { title: 'Compensate con il nostro supporto.', text: 'Un tecnico è disponibile 24 ore su 24, 7 giorni su 7, per qualsiasi domanda.' },
            { title: 'Ricevete i certificati.', text: 'La nuova tabella delle deviazioni e i certificati via e-mail.' },
        ],
        imgAlt: 'Piattaforma online',
        figcaption: 'Tutte le informazioni della bussola in un unico posto, sulla nostra piattaforma online.',
        advShipTitle: 'Vantaggi per la nave',
        advShip: [
            'Compensazione durante la navigazione, senza scalo in porto né ritardi nel viaggio',
            'Un tecnico disponibile 24 ore su 24, 7 giorni su 7',
        ],
        advOwnersTitle: 'Vantaggi per armatori e società di gestione',
        advOwners: [
            'Nessun costo di imbarco e sbarco del tecnico',
            "Prezzo fisso, senza sovrapprezzi in base al giorno o all'orario; più conveniente sui volumi",
        ],
        howItWorks: 'Come funziona',
        onboardTitle: 'Taratura a bordo',
        onboardText: 'Un tecnico a bordo compensa manualmente la bussola magnetica e rilascia i certificati, firmati digitalmente dal tecnico e dal comandante.',
        onboardSteps: [
            'Il tecnico indica al comandante le manovre da eseguire per verificare e compensare la bussola magnetica secondo necessità.',
            'Una volta corrette tutte le deviazioni, il tecnico rilascia a bordo i certificati con tutte le convalide legali e internazionali, firmati digitalmente dal tecnico e dal comandante.',
        ],
        repairTitle: 'Riparazione di bussole magnetiche',
        repairText: 'Spedite o portate la vostra bussola al nostro laboratorio. Riparata in meno di 24 ore, con certificato di revisione e un anno di garanzia.',
        repairSteps: [
            'La bussola magnetica viene ispezionata per individuare il guasto.',
            'Uno dei nostri tecnici la ripara in meno di 24 ore.',
            'Una volta riparata, il nostro tecnico rilascia il certificato di revisione della bussola, con un anno di garanzia incluso.',
        ],
    },
    contact: {
        title: 'Contatti',
        intro: 'Vi serve un preventivo o avete una domanda? I nostri tecnici vi risponderanno.',
        getInTouch: 'Contattateci',
        getInTouchText: 'Chiamateci, scriveteci o inviateci un messaggio. Rispondiamo da qualsiasi parte del mondo.',
        international: 'USA / Internazionale',
        technical: 'Reparto tecnico',
        email: 'E-mail',
        laboratory: 'Laboratorio',
        openMaps: 'Apri in Maps',
        whatsapp: 'Scriveteci su WhatsApp',
        showEmail: 'Mostra e-mail',
        form: {
            title: 'Inviateci un messaggio',
            required: 'Tutti i campi sono obbligatori.',
            name: 'Nome e cognome',
            email: 'E-mail',
            phone: 'Cellulare',
            enterprise: 'Azienda',
            subject: 'Oggetto',
            message: 'Messaggio',
            recaptcha: 'Protetto da reCAPTCHA.',
            send: 'Invia messaggio',
            sending: 'Invio in corso... Attendere prego.',
            sendError: 'Si è verificato un errore! Riprovate più tardi o scriveteci direttamente via e-mail.',
        },
        errors: {
            name: 'Il nome è obbligatorio',
            email: "L'e-mail è obbligatoria",
            emailInvalid: "L'e-mail non è valida",
            phone: 'Il cellulare è obbligatorio',
            enterprise: "L'azienda è obbligatoria",
            subject: "L'oggetto è obbligatorio",
            message: 'Il messaggio è obbligatorio',
        },
    },
    footer: {
        slogan: 'Servizi e certificati per bussole magnetiche dal 1939',
        terms: 'Termini e condizioni',
        policy: 'Privacy',
    },
}

export default it
